import { jsx } from 'react/jsx-runtime';
import usePhysicalMetrics from '../../hooks/usePhysicalMetrics.js';
import { SpeedMetric } from '../../types/speed.js';
import Speed from '../../components/Speed/Speed.js';

function PhysicalMetrics({ currentTimestamp, playerId, playId, options, threshold, x, y, }) {
    const { speed: rawSpeed } = usePhysicalMetrics({ currentTimestamp, options, playerId, playId }) || {};
    const speed = +(rawSpeed || 0).toFixed(1);
    return (jsx(Speed, { fastest: !!(threshold && threshold < speed), metric: (options === null || options === void 0 ? void 0 : options.metric) || SpeedMetric.MPH, x: x, y: y, children: speed }));
}

export { PhysicalMetrics as default };
//# sourceMappingURL=PhysicalMetrics.js.map
